import React from 'react';

import ErrorMessage from 'components/vistaprintUILibrary/ErrorMessage';
import { colors } from 'settings/theme';
import UnicodeUtil from 'utils/UnicodeUtil';

export default function TextField(props) {
    const {
        value, // required
        onChange, // required
        label = undefined,
        fullWidth = false,
        id = undefined, // required if label is provided (to link label and input)
        success = false,
        errorMessage = undefined,
        autoCompleteCategory = undefined,
        required = false,
        disabled = false,
        containerStyle = {},
        labelStyle = {},
        style = {},
        ...restProps, // additional props will be added to the input element
    } = props;

    if (label && !id) {
        throw new Error('"id" property is required if "label" is provided. "id" is needed to link the label and input elements');
    }

    let errorStyle = {};
    if (errorMessage !== null) {
        errorStyle = {
            borderColor: colors.danger,
            boxShadow: `inset 0 0 0 1px ${colors.danger}`,
        };
    }

    let successStyle = {};
    if (success) {
        errorStyle = {
            successStyle: colors.success,
            boxShadow: `inset 0 0 0 1px ${colors.success}`,
        };
    }

    return (
        <form // the input needs to be inside of a form element for chrome autofill to work
            style={containerStyle}
        >
            {label &&
                <label
                    className="above"
                    htmlFor={id}
                    style={labelStyle}
                >
                    {`${label}${required ? '*' : ''}`}
                </label>
            }
            <div
                style={{
                    position: 'relative',
                }}
            >
                <input
                    id={id}
                    type="text"
                    className={'stylized-input'}
                    disabled={disabled}
                    autoComplete={autoCompleteCategory}
                    value={value}
                    onChange={onChange}
                    style={{
                        width: fullWidth ? '100%' : undefined,
                        ...style,
                        ...errorStyle,
                        ...successStyle,
                    }}
                    {...restProps}
                />
                {success &&
                    <div
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: '50%',
                            transform: 'translateY(-50%)',

                            backgroundColor: colors.success,
                            color: 'white',
                            borderRadius: '50%',
                            height: 20,
                            width: 20,

                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {UnicodeUtil.heavyCheckMark}
                    </div>
                }
                {errorMessage &&
                    <span
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: '50%',
                            transform: 'translateY(-50%)',

                            backgroundColor: colors.danger,
                            color: 'white',
                            borderRadius: '50%',
                            height: 20,
                            width: 20,

                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {UnicodeUtil.heavyBallotX}
                    </span>
                }
            </div>

            <ErrorMessage containerStyle={{ marginTop: 3 }} text={errorMessage} />
        </form>
    )
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/TextField.js